// Launch Darkly feature flags
export const HOS_EDIT_ALLOW_ODOMETER_EDITS = 'fflag.hos.edit.allowOdometerEditsWhenNull';
export const SHOW_HOS_LOGS_ACTIVITY_SUMMARY = 'fflag.hos.show.hosActivitySummary';
export const LAUNCH_DARKLY_FEATURE_FLAGS = {
  [HOS_EDIT_ALLOW_ODOMETER_EDITS]: false,
  [SHOW_HOS_LOGS_ACTIVITY_SUMMARY]: false,
};
